import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    imports: [TranslocoModule, MatButtonModule],
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrl: './maintenance.component.scss'
})
export class MaintenanceComponent {
  constructor(private router: Router) {}

  backToLogin() {
    this.router.navigate(['']);
  }
}
